import { useMemo } from 'react';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { CMRI_OVERVIEW_PAGE_CONST } from './constants';

export const useCmriOverviewSidebar = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(CMRI_OVERVIEW_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        return sidebarCollapsed ? '35px' : '200px';
    }, [sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
    };
};
